import React from 'react'
import styled from 'styled-components'
import Image from 'next/image'
import LazyLoad from 'react-lazyload'
import { createResource, useResource } from '@/lib/i18n'
import { useWindowSize } from '@/lib/use-hooks/use-window-size'

const resource = createResource({
  en: {
    title: `Why work with us`,
    content:
      'We are fast growing startup company. We have a vision to help the communities in Indonesia, build and achieving financial inclusion. Working with us will not only develop your career but also develop yourself. You can also enlarge your network globally with us.',
  },
  id: {
    title: 'Mengapa bekerja dengan kami',
    content:
      'Kami adalah perusahaan start-up yang sedang berkembang pesat. Kami memiliki visi untuk membantu masyarakat Indonesia, bersama kita bangun dan tingkatkan inklusi finansial. Bekerja dengan kami tidak hanya mengembangkan karir mu tapi juga mengembangkan kepribadianmu. Kamu pun dapat memperluas networkingmu secara global bersama kami.',
  },
})

const WorkWithUs = () => {
  const { t } = useResource(resource)
  const { width } = useWindowSize()
  return (
    <BannerBox>
      {width >= 1000 ? (
        <div className="container">
          <div className="left-image">
            <LazyLoad>
              <Image
                src="/images/career/work-with-us.png"
                alt="Why work with us"
                width={403}
                height={326}
                quality={85}
              />
            </LazyLoad>
          </div>
          <div className="right-content">
            <div className="title">{t('title')}</div>
            <div className="content">{t('content')}</div>
          </div>
        </div>
      ) : (
        <div className="container">
          <div className="title">{t('title')}</div>
          <div className="left-image">
            <LazyLoad>
              <Image
                src="/images/career/work-with-us.png"
                alt="Why work with us"
                width={403}
                height={326}
                quality={85}
              />
            </LazyLoad>
          </div>
          <div className="right-content">
            <div className="content">{t('content')}</div>
          </div>
        </div>
      )}
    </BannerBox>
  )
}

export default WorkWithUs

const BannerBox = styled.div`
  @media only screen and (max-width: 1000px) {
    margin-top: 48px;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    .container {
      position: relative;
      width: 100%;
      margin: 0 auto;
      padding: 0 24px;
      .title {
        font-size: 32px;
        font-family: Roboto-Medium, Roboto;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.87);
        line-height: 36px;
        text-align: center;
        padding-bottom: 16px;
      }
      .right-content {
        .content {
          padding-top: 24px;
          font-size: 16px;
          font-family: Roboto-Regular, Roboto;
          font-weight: 400;
          color: #757575;
          line-height: 32px;
        }
      }
    }
  }
  @media only screen and (min-width: 1000px) {
    max-width: 1440px;
    margin: 100px auto 0;
    background-repeat: no-repeat;
    .container {
      width: 100%;
      max-width: 1440px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      padding: 0 150px;
      .left-image {
        width: 403px;
        height: 326px;
      }
      .right-content {
        width: 576px;
        .title::before {
          content: '-';
          background: #1cc812;
          color: transparent;
          margin-right: 16px;
        }
        .title {
          font-size: 32px;
          font-family: Roboto-Medium, Roboto;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.87);
          line-height: 36px;
          padding-top: 60px;
        }
        .content {
          padding-top: 35px;
          font-size: 16px;
          font-family: Roboto-Regular, Roboto;
          font-weight: 400;
          color: #212121;
          line-height: 32px;
        }
      }
    }
  }
`
